import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  data: { results: [] },
  loading: false,
  error: null,
}

export const contactMethodsSlice = createSlice({
  name: 'contactmethods',
  initialState,
  reducers: {
    loadContactMethods(state) {
      state.loading = true
      state.error = null
    },
    storeContactMethods(state, action) {
      state.loading = false
      state.error = null
      state.data = action.payload
    },

    addContactMethodRequest() {},
    updateContactMethodRequest() {},
    deleteContactMethodRequest() {},

    addContactMethodSuccess(state, action) {
      state.data.results.unshift(action.payload)
      state.error = null
    },
    updateContactMethodSuccess(state, action) {
      const idx = state.data.results.findIndex(
        cm => cm.id === action.payload.id
      )
      if (idx !== -1) {
        state.data.results[idx] = action.payload
      }
      state.error = null
    },
    deleteContactMethodSuccess(state, action) {
      state.data.results = state.data.results.filter(
        cm => cm.id !== action.payload
      )
      state.error = null
    },

    clearContactMethods(state) {
      state.data = { results: [] }
      state.error = null
    },
    setContactMethodsError(state, action) {
      state.loading = false
      state.error = action.payload
    },
    clearContactMethodsError(state) {
      state.error = null
    },
  },
})

export const {
  loadContactMethods,
  storeContactMethods,
  addContactMethodRequest,
  addContactMethodSuccess,
  updateContactMethodRequest,
  updateContactMethodSuccess,
  deleteContactMethodRequest,
  deleteContactMethodSuccess,
  clearContactMethods,
  setContactMethodsError,
  clearContactMethodsError,
} = contactMethodsSlice.actions

export default contactMethodsSlice.reducer
